<template>

    <div class="flex-1 bg-[#f5f4f9] pt-8 grid gap-4 p-4 lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 grid-cols-1">
        <div
            class="
                bg-white rounded-[15px]
                lg:order-1
                md:order-6
                sm:order-6
                order-6
            "
        >
            <MarketPairs />
        </div>

        <div
            class="
                bg-white rounded-[15px]
                lg:col-span-2 lg:order-2
                md:col-span-2 md:order-1
                sm:order-1
                order-1
                overflow-hidden
            "
        >
<!--            <div class="switch col-xl-3 col-lg-3">-->
<!--                <button @click="switchDarkTheme" value="Switch to Dark Theme" class="dark-theme btn-info">{{ switchBtnText }}</button>-->
<!--            </div>-->
            <Chart ref="chartComp"/>
        </div>

        <div
            class="
                bg-white rounded-[15px] row-span-2
                lg:order-3
                md:order-4
                sm:order-4
                order-4
            "
        >
            <OrderBook />
        </div>

        <div
            class="
                bg-white rounded-[15px]
                lg:order-4
                md:order-5
                sm:order-5
                order-5
            "
        >
            <TradeHistory />
        </div>

        <div
            class="
                bg-white rounded-[15px]
                lg:order-5
                md:order-2
                sm:order-2
                order-2
            "
        >
            <BuyCoin />
        </div>

        <div
            class="
                bg-white rounded-[15px]
                lg:order-6
                md:order-3
                sm:order-3
                order-3
            "
        >
            <SellCoin />
        </div>

        <div
            class="
                bg-white rounded-[15px]
                lg:order-7 lg:col-span-2
                md:order-7 md:col-span-2
                sm:order-7
                order-7
            "
        >
           <MyOpenOrders />
        </div>

        <div
            class="
                bg-white rounded-[15px]
                lg:order-8 lg:col-span-2
                md:order-8 md:col-span-2
                sm:order-8
                order-8
            "
        >
            <MyTradingHistory />
        </div>

        <div
            class="
                bg-white rounded-[15px]
                lg:order-9 lg:col-span-2
                md:order-9 md:col-span-2
                sm:order-9
                order-9
            "
        >
            <CoinInfo />
        </div>

        <div
            class="
                bg-white rounded-[15px]
                lg:order-10 lg:col-span-2
                md:order-10 md:col-span-2
                sm:order-10
                order-10
            "
        >
            <CoinInfo2 />
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { OrderBook, MarketPairs, TradeHistory, InputTerminal, Chart, MarketDataInfo, Orders } from "../components"
import JsCookie from "js-cookie";
import CoinInfo from "@/components/Exchange/CoinInfo.vue";
import CoinInfo2 from "@/components/Exchange/CoinInfo2.vue";
import BuyCoin from "@/components/Exchange/BuyCoin.vue";
import SellCoin from "@/components/Exchange/SellCoin.vue";
import MyTradingHistory from "@/components/Exchange/MyTradingHistory.vue";
import MyOpenOrders from "@/components/Exchange/MyOpenOrders.vue";

const chartComp = ref(null)
const switchBtnText = ref('Switch to Dark Theme')

onMounted(()=>{
    window.addEventListener("resize", ()=>maxWidth.value = window.matchMedia("(max-width: 1280px)"));
})

let maxWidth = ref(window.matchMedia("(max-width: 1280px)"));


onMounted(() => {
    if (JsCookie.get('darkmode') === "Dark") {
        $('body').toggleClass('darkmode');
        switchBtnText.value = 'Switch to Light Theme'
    }
})

const switchDarkTheme = () => {
    if (JsCookie.get('darkmode') === "Dark") {
        JsCookie.remove('darkmode');
        switchBtnText.value = 'Switch to Dark Theme'
    } else {
        JsCookie.set('darkmode', "Dark");
        switchBtnText.value = 'Switch to Light Theme'
    }

    $('body').toggleClass('darkmode');
    chartComp.value.loadChart()
}
</script>

